import React from 'react';
import styles from './css/PortraitImage.styl';
import _ from 'lodash';
import {GalleryIcon} from '../../../../shared/Svgs';
import {buildUrl} from '../../../../shared/utilities/urlHelpers';

const CANDLE_JPG = require('./assets/candle.jpg');

/**
 * The portait image item in the hero section of the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns a portait image
 */
const PortraitImage = props => {
  const {
    firstname,
    galleryCount,
    lastname,
    isValidImage,
    portraitImage,
    showPortrait,
    showGalleryHandler,
  } = props;
  const altText = [firstname, lastname, 'Obituary']
    .filter(text => text)
    .join('-');

  let image = (
    <div className={styles.PortraitImage}>
      <div className={styles.imageHolder}>
        <div className={styles.image}>
          <img alt={altText} src={CANDLE_JPG} />
        </div>
      </div>
    </div>
  );

  const hasLink = showPortrait || galleryCount;

  if (isValidImage && portraitImage) {
    const {attribution, cacheUrl} = props;

    image = (
      <div className={styles.PortraitImage}>
        <div className={styles.imageHolder}>
          <div className={styles.image}>
            <img
              alt={altText}
              className={hasLink ? styles.active : ''}
              onClick={hasLink ? _.partial(showGalleryHandler, 0) : null}
              src={`${buildUrl(cacheUrl, portraitImage)}`}
            />
            {hasLink ? <GalleryIcon /> : null}
          </div>
          {attribution ? (
            <p className={styles.imageAttribution}>
              Photo courtesy of {attribution}
            </p>
          ) : null}
        </div>
      </div>
    );
  }

  return image;
};

PortraitImage.propTypes = {
  attribution: React.PropTypes.string,
  cacheUrl: React.PropTypes.string,
  firstname: React.PropTypes.string,
  galleryCount: React.PropTypes.number,
  isValidImage: React.PropTypes.bool,
  lastname: React.PropTypes.string,
  portraitImage: React.PropTypes.string,
  showGalleryHandler: React.PropTypes.func,
  showPortrait: React.PropTypes.bool,
};

export default PortraitImage;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/PersonHero/PortraitImage.js